import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";
import { endpoint, publicEnvVars, type WinrmDefaults } from "./shared";

const DEFAULTS: WinrmDefaults = { port: "5986" };
const IDENTIFY_REQUEST =
  '<s:Envelope xmlns:s="http://www.w3.org/2003/05/soap-envelope" xmlns:wsmid="http://schemas.dmtf.org/wbem/wsman/identity/1/wsmanidentity.xsd"><s:Header/><s:Body><wsmid:Identify/></s:Body></s:Envelope>';

export const winrm = defineConnector({
  identifier: "winrm",
  name: "WinRM",
  tagLine: "Run commands on a Windows host over WinRM",
  keywords:
    "winrm windows powershell ws-management ntlm active directory remote management",
  aiContext:
    "WinRM (WS-Management) over HTTPS. Use pywinrm’s Basic transport with WINRM_ENDPOINT, WINRM_USERNAME, and the placeholder WINRM_PASSWORD. The proxy removes the placeholder authorization and performs NTLM with the connector’s service-account credential.",
  logo,
  tags: ["it", "custom"],
  protocol: "winrm",
  connectionTest: {
    protocol: "http",
    request: (config) => ({
      url: endpoint(config.host, config.port, DEFAULTS),
      method: "POST",
      headers: { "Content-Type": "application/soap+xml;charset=UTF-8" },
      body: IDENTIFY_REQUEST,
      expectedStatus: 200,
      expectedBodyContains: "IdentifyResponse",
    }),
  },
  defaultUrlPattern: () => "",
  customizeStepHandledInline: true,
  auth: customAuth("winrm"),
  steps: [
    {
      title: "Enter your WinRM connection",
      items: [
        {
          kind: "input",
          label: "Name",
          required: true,
          defaultValue: "WinRM",
          target: { kind: "connectedApp", field: "name" },
        },
        {
          kind: "input",
          label: "Host",
          required: true,
          placeholder: "dc.corp.example.com",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "Port",
          required: true,
          defaultValue: "5986",
          target: { kind: "configuration", field: "port" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          placeholder: "CORP\\service-account",
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
        {
          kind: "file",
          label: "CA certificate",
          accept: ".pem,.crt,.cer",
          helperText:
            "Upload a PEM CA certificate for the WinRM HTTPS listener (required for private or self-signed certificates).",
          target: { kind: "configuration", field: "tlsCaCertificate" },
        },
      ],
    },
  ],
  publicEnvVars: (config) => publicEnvVars(config, DEFAULTS),
  usageHint: () =>
    "Use pywinrm’s Basic transport with WINRM_ENDPOINT, WINRM_USERNAME, and WINRM_PASSWORD, and leave server certificate validation enabled. WINRM_PASSWORD is a placeholder — send it as-is. The proxy removes the placeholder authorization and performs NTLM with the connector’s credential over HTTPS.",
});
